import DialogVisible from '@/app-core/mixins/dialog/dialogVisible'
import VSeparator from '@/app-theme/components/widgets/VSeparator.vue'
import DialogData from '@/app-core/mixins/dialog/dialogData'
import LoginModel from '@/app-core/api/models/user/LoginModel'
import Auth from '@/app-core/mixins/auth'

export default {
  name      : 'LoginDialog',
  components: {VSeparator},
  mixins    : [DialogVisible, DialogData, Auth],
  props     : {},
  dataModel : LoginModel,
  data() {
    return {}
  },
  computed: {
    facebookLoginProviderEnabled() {
      return !!this.AppConfig?.Auth?.Facebook
    },

    googleLoginProviderEnabled() {
      return !!this.AppConfig?.Auth?.Google
    },

    emailLoginProviderEnabled() {
      return !!this.AppConfig?.Auth?.Email
    }
  },
  methods: {
    onLoginClick() {
      this.saveFromData()
    },

    saveFromData() {
      if (!this.validateForm() || this.isFormSaving) return
      if (typeof this.clearServerErrorMessages === 'function') this.clearServerErrorMessages()

      this.isFormSaving = true

      this.login(this.model.Username, this.model.Password)
    },

    onRegisterClick() {
      this.closeDialog()
      this.$bus.$emit('register:show-dialog')
    },

    onForgotPasswordClick() {
      this.closeDialog()
      this.$bus.$emit('reset-password:show-dialog')
    }
  }
}
